import { useState } from "react"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"

interface DetailsSheetProps {
  onClose: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export function DetailsSheet({ onClose, title, children }: DetailsSheetProps) {
  const [isOpen, setIsOpen] = useState(true)
  const onOpenChange = (open: boolean) => {
    setIsOpen(open)
    setTimeout(() => onClose(open), 400)
  }

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent className="w-full md:w-5/12 md:max-w-xl">
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  )
}
